'use client'

import { layoutPadding } from '@/core/constants/class-names'
import { QUERY_ROUTES, ROUTES } from '@/core/constants/routes'
import { useAuth } from '@/core/store/auth'
import { Link, usePathname } from '@/i18n/navigation'
import { Avatar } from '@heroui/avatar'
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownTrigger,
} from '@heroui/dropdown'
import {
  Navbar,
  NavbarBrand,
  NavbarContent,
  NavbarItem,
  NavbarMenu,
  NavbarMenuToggle,
} from '@heroui/navbar'
import Image from 'next/image'
import { useEffect, useState } from 'react'
import { Button } from '../atoms/button'
import { NavLinks } from './nav-links'
import { LogoutForm } from '@/features/auth'
import { useTranslations } from 'next-intl'
import { useSearchParams } from 'next/navigation'
type HeaderProps = {
  store_address: string
}
export default function Header({ store_address }: HeaderProps) {
  const t = useTranslations()
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const { isAuthenticated, user } = useAuth()
  const pathname = usePathname()
  const searchParams = useSearchParams()
  useEffect(() => {
    setIsMenuOpen(false)
  }, [pathname, searchParams])
  const getHref = () => {
    const login = QUERY_ROUTES.login
    const searchParams = new URLSearchParams()
    searchParams.set(login.name, login.value)
    return `${pathname}?${searchParams.toString()}`
  }

  return (
    <Navbar
      isMenuOpen={isMenuOpen}
      onMenuOpenChange={setIsMenuOpen}
      isBordered
      className='border-b border-[#F5F5F5] bg-white py-1 shadow-sm'
      maxWidth='full'
      classNames={{
        wrapper: layoutPadding,
      }}
    >
      <NavbarContent className='w-full'>
        <div className='container mx-auto flex w-full items-center justify-between gap-6 px-4 sm:px-10 md:px-12'>
          <div className='flex items-center gap-3'>
            <NavbarMenuToggle
              aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
              className='text-creamed-cron block h-5 w-5 lg:hidden'
            />
            <NavbarBrand className='flex items-center'>
              <Link href={ROUTES.home}>
                <Image
                  src='/images/logo.png'
                  alt='Future Way'
                  width={80}
                  height={40}
                  className='object-contain'
                />
              </Link>
            </NavbarBrand>
          </div>
          <NavLinks className='hidden lg:flex' store_address={store_address} />
        </div>
      </NavbarContent>
      <NavbarContent justify='end' className='!grow-0'>
        {isAuthenticated ? (
          <Dropdown placement='bottom-end'>
            <DropdownTrigger>
              <Avatar name={user?.username} />
            </DropdownTrigger>
            <DropdownMenu aria-label='Profile Actions' variant='flat'>
              <DropdownItem key='profile' className='h-14 gap-2'>
                <p className='font-semibold'>{t('header.signedInAs')}</p>
                <p className='font-semibold'>{user?.username}</p>
              </DropdownItem>
              <DropdownItem key='settings'>
                <Link href={ROUTES.profile} className='block w-full'>
                  {t('actions.myProfile')}
                </Link>
              </DropdownItem>

              <DropdownItem key='logout' color='danger'>
                <LogoutForm>
                  <button className='w-full cursor-pointer text-start'>
                    {t('actions.logOut')}
                  </button>
                </LogoutForm>
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
        ) : (
          <NavbarItem>
            <Button component={Link} href={getHref()} variant='contained'>
              {t('actions.Login')}
            </Button>{' '}
          </NavbarItem>
        )}
      </NavbarContent>

      <NavbarMenu className='space-y-5 px-5 pt-8'>
        <NavLinks
          className='flex-col justify-start lg:hidden'
          store_address={store_address}
          onNavigate={() => setIsMenuOpen(false)}
        />
      </NavbarMenu>
    </Navbar>
  )
}
